module.exports = __webpack_public_path__ + "static/media/8C.55a0952d.svg";